import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetDashboardResponse } from './get-dashboard-response';
import { getDashboardResponseSchema } from './get-dashboard-response';

export async function getDashboardApi(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetDashboardResponse>> {
  return getRequest<IGetDashboardResponse>({
    path: '/progress/dashboard',
    schema: getDashboardResponseSchema,
    options,
  });
}
